import { render } from "./BaseSubpage.vue?vue&type=template&id=7aa0983b"
import script from "./BaseSubpage.vue?vue&type=script&lang=js"
export * from "./BaseSubpage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__